module.exports = new __parcel__URL__("gosat-based-ch4budget-yeargrid-v1.thumbnails.posterior.wetlands.uncertainty.6ca965fa.png").toString();